export default __webpack_public_path__ + "static/visual-insights-f70b05a7e67e539934f6bf62976a2d9b.jpg";